const emailRegex = /\S+@\S+\.\S+/

export function isEmail(email: string) {
  return emailRegex.test(email)
}
